import { useMemo } from 'react';
import { CheckCircleOutlined, StopOutlined } from '@ant-design/icons';

export const useStatusRender = () => {
  return useMemo(
    () => (status: number | boolean) => {
      // Convert numeric status to boolean
      const isActive = status === 1 || status === true;

      const statusConfigs: Record<
        string,
        {
          text: string;
          icon: React.ReactNode;
          bgColor: string;
          textColor: string;
          borderColor: string;
        }
      > = {
        true: {
          text: 'Active',
          icon: <CheckCircleOutlined />,
          bgColor: '#f6ffed',
          textColor: '#52c41a',
          borderColor: '#b7eb8f',
        },
        false: {
          text: 'Inactive',
          icon: <StopOutlined />,
          bgColor: '#fafafa',
          textColor: '#000000e0',
          borderColor: '#d9d9d9',
        },
      };

      return statusConfigs[String(isActive)] || statusConfigs['false'];
    },
    []
  );
};
